<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Jméno (stačí křestní)"
          :value="local.name"
          @input="update('name', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
          label="Věk"
          :value="local.age"
          @input="update('age', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["value"],
  computed: {
    local() {
      return this.value ? this.value : {};
    }
  },
  methods: {
    update(key, target) {
      this.$emit("input", { ...this.local, [key]: target });
    }
  }
};
</script>
